import React from 'react';
import PropTypes from 'prop-types';

const Cell = ({ data, cell, cellProps, props, ...column }) => {
    const content =
        typeof cell === 'function'
            ? cell({ data, column, ...cellProps })
            : data[column.field];

    return <td {...props}>{content}</td>;
};

Cell.propTypes = {
    data: PropTypes.object,
    props: PropTypes.object,
    cell: PropTypes.func,
    cellProps: PropTypes.object,
    field: PropTypes.string
};

export default Cell;
